import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CHILD_PROFILE/PLANS';

export const {
    action: fetchChildPlansData,
    success: fetchChildPlansDataSuccess,
    failed: fetchChildPlansDataFailed,
} = createAction(`${domain}/FETCH_CHILD_PLANS_DATA`, (institutionId, childId) => ({institutionId, childId}));

export const {
    action: addDateOfBirth,
    success: addDateOfBirthSuccess,
    failed: addDateOfBirthFailed,
} = createAction(`${domain}/UPDATE_DATE_OF_BIRTH`, (childId, dateOfBirth) => ({childId, dateOfBirth}));
